import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import LandingPage from "./pages/LandingPage";
import Register from "./components/Register";
import CreateTripPage from "./pages/CreateTripPage";
import EditTripPage from "./pages/EditTripPage";
import Profile from "./pages/Profile"; 
import VerifyEmail from "./pages/VerifyEmail";
import Terms from "./pages/Terms";

const App = () => {
  return (
    <Router>
      <Routes>
		<Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
		<Route path="/profile" element={<Profile />} /> 
		<Route path="/create-trip" element={<CreateTripPage />} />
		<Route path="/edit-trip/:tripId" element={<EditTripPage />} />
		<Route path="/verify_email" element={<VerifyEmail />} />
		<Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
};

export default App;